import { render } from "./PrivacyOnlineDeposits.vue?vue&type=template&id=73967b8b"
const script = {}

import exportComponent from "/home/leviathan/sites/webbank/webbank-static/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__